import React, {useContext} from 'react';
import {useIntl} from 'react-intl';

import {Descriptions, Tag} from 'antd';
import {LocationContext} from '../LocationContext';
import {addressText, isEmptyObject} from 'utils/Utils';
import {Link} from 'react-router-dom';

const LocationInfo = () => {
  const intl = useIntl();

  const locationContext = useContext(LocationContext);
  const {selectedLocation} = locationContext;

  return (
    <>
      <Descriptions
        bordered
        title={selectedLocation?.name}
        size='middle'
        style={{padding: 10}}>
        <Descriptions.Item label={intl.messages['location.name']}>
          {selectedLocation?.name}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['location.status']}>
          <Tag color='red'>
            {selectedLocation?.status
              ? intl.messages[
                  `location.status.${selectedLocation.status.toLowerCase()}`
                ]
              : ''}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['common.phoneNumber']}>
          {selectedLocation?.phone}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['common.email']}>
          {selectedLocation?.email}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['location.organization']}>
          {selectedLocation?.organization && (
            <Tag color='green'>
              <Link
                to={`/health/organizations/${selectedLocation.organization.id}`}>
                {selectedLocation.organization.name}
              </Link>
            </Tag>
          )}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['location.partOf']}>
          {selectedLocation?.partOf && (
            <Tag color='green'>
              <Link to={`/health/locations/${selectedLocation.partOf.id}`}>
                {selectedLocation.partOf.name}
              </Link>
            </Tag>
          )}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['location.position']}>
          {!isEmptyObject(selectedLocation?.position)
            ? `${selectedLocation?.position?.longitude} - ${selectedLocation?.position?.latitude}`
            : ''}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['address']} span={5}>
          {addressText(selectedLocation?.address)}
        </Descriptions.Item>
        <Descriptions.Item
          label={intl.messages['location.description']}
          span={5}>
          {selectedLocation?.description}
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};

export default LocationInfo;
